import { useMutation, useQueryClient } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';
import { Label } from 'types';

type UpdateLabelData = {
  name?: string;
  color?: string;
};

const updateLabel = async (labelId: string, updateData: UpdateLabelData): Promise<Label> => {
  const response = await customAxios.patch<Label>(`/labels/${labelId}`, updateData);
  return response.data;
};

export const useUpdateLabel = (orgId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ labelId, updateData }: { labelId: string; updateData: UpdateLabelData }) =>
      updateLabel(labelId, updateData),
    onSuccess: () => {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      queryClient.invalidateQueries({ queryKey: ['labels', orgId] }).catch(() => undefined);
    },
  });
};
